import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { LocationLabelLinkContainerModel } from '../../../../../../models/aggregates/erp/organisation-labels';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class LocationLabelLinkService extends BaseApiTemplateService<LocationLabelLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.ORGANISATION_PREFIX + "location-label-links/backoffice-ep";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.ORGANISATION_PREFIX + "location-label-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.ORGANISATION_PREFIX + "location-label-links/backoffice-ep";
    this.httpClient = http;
  }
}